import { lazy } from "react";
import Loadable from "app/components/Loadable";

const BillingWorkspace = Loadable(lazy(() => import("./BillingWorkspace")));

const PatientBillingRoutes = [
  { path: "/patients/billing/create", element: <BillingWorkspace /> },
  {
    path: "/patients/billing/create/visit/:visitId",
    element: <BillingWorkspace />,
  },
];

export default PatientBillingRoutes;
